
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import OnboardingFlow from '@/components/onboarding/OnboardingFlow';

const HomeApp = () => {
  const [showOnboarding, setShowOnboarding] = useState(false);

  if (showOnboarding) {
    return <OnboardingFlow />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-soft via-blue-whisper to-white flex items-center justify-center px-4">
      <div className="text-center max-w-sm mx-auto">
        {/* Logo Section */}
        <div className="mb-8">
          <h1 className="text-5xl font-bold text-slate-dark mb-6 font-sans tracking-tight">
            Show Up!
          </h1>
        </div>

        {/* Motivational Text */}
        <div className="mb-8 space-y-3">
          <p className="text-lg text-slate-medium font-medium leading-relaxed">
            Thanks for showing up.
          </p>
          <p className="text-base text-slate-light">
            Don't forget: show up again tomorrow.
          </p>
        </div>

        {/* CTA Button */}
        <Button
          onClick={() => setShowOnboarding(true)}
          className="w-full h-14 text-lg font-semibold bg-blue-primary hover:bg-blue-light text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98]"
        >
          Get Started
        </Button>
      </div>
    </div>
  );
};

export default HomeApp;
